import React from 'react'
import { Space } from 'antd'
import Collapse from 'antd/lib/collapse'
import { SolidLineIcon } from './nodes'
import { BasicNode, BasicShape } from './BasicNode'
import Icon from '@ant-design/icons'

const { Panel } = Collapse

export const TemplateMenu = () => {
  return <Collapse>
    <Panel header="Basic" key='basic'>
      <Space wrap size={20}>
        <BasicNode
          type={BasicShape.Line}
          component={<SolidLineIcon style={{width: '100%'}} />} title={'Line'}/>
        <BasicNode
          type={BasicShape.Text}
          component={<TextIcon style={{width: '100%'}} />} title={'Text'}/>
        <BasicNode
          type={BasicShape.Image}
          component={<img src="/images/default.jpg" style={{width: '100%'}} />} title={'Image'}/>
      </Space>
    </Panel>
  </Collapse>
}


const TextSvg = () => {
  return (
    <svg
      viewBox='0 0 1024 1024'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      p-id='2337'
      width='100%'
      height='100%'
    >
      <path
        d='M320 896c64 0 96-74.88 96-128V192H270.72a96 96 0 0 0-94.08 77.12L160 352H96V128a64 64 0 0 1 64-64h704a64 64 0 0 1 64 64v224h-64l-16.64-82.88A96 96 0 0 0 753.28 192H608v576c0 53.12 32 128 96 128v64H320z'
        fill='#231F20'
        p-id='2338'
      ></path>
    </svg>
  )
}

export const TextIcon = (props: any) => <Icon component={TextSvg} {...props} />